export class Customer {
  id: number;
  accountName: string;
  accountId: string;
  createdBy: string;
  createdDate: number;
  modifiedBy: string;
  modifiedDate: number;
  idpType: string;
  guid: string;

  public constructor(init?: Partial<Customer>) {
    Object.assign(this, init);
  }

}
